import {RecordAuditDefinitionResponseBody} from '@dms/api/core';

import {RecordAuditDefinitionFormValue} from '../types/RecordAuditDefinitionFormValue';

export const toRecordAuditDefinitionFormValue = (
  data: RecordAuditDefinitionResponseBody
): RecordAuditDefinitionFormValue => ({
  name: data.name,
  resourceId: data.resourceId,
  description: data.description,
  category: data.category,
  successThreshold: data.successThreshold ?? null,
  sections: (data.sections ?? []).map((section) => ({
    id: section.id,
    name: section.name,
  })),
  tasks: data.tasks.map((task) => ({
    id: task.id,
    description: task.description,
    isMandatory: task.isMandatory,
    fileRequired: task.fileRequired,
    weight: task.weight ?? 1,
    sectionId: task.sectionId ?? null,
  })),
});
